module.exports = __webpack_public_path__ + "img/autenticidad-1.7867b04f.gif";